var map = {
	"./abalone.svg": 34098,
	"./acornsquash.svg": 28876,
	"./alcohol.svg": 4730,
	"./alfalfasprouts.svg": 42385,
	"./almonds.svg": 63552,
	"./apples.svg": 63409,
	"./apricots.svg": 66239,
	"./artichokes.svg": 13125,
	"./arugula.svg": 83383,
	"./asparagus.svg": 12909,
	"./avocados.svg": 59340,
	"./bacon.svg": 80269,
	"./bagel.svg": 61941,
	"./bananas.svg": 36750,
	"./bean.svg": 908,
	"./beansprouts.svg": 13140,
	"./beef.svg": 99320,
	"./beetgreens.svg": 16334,
	"./beets.svg": 47939,
	"./beverage.svg": 68025,
	"./blackberries.svg": 40933,
	"./blondies.svg": 38486,
	"./blueberries.svg": 10340,
	"./bokchoy.svg": 8045,
	"./boysenberries.svg": 83928,
	"./brazilnuts.svg": 55816,
	"./bread.svg": 9570,
	"./broccoli.svg": 30967,
	"./broccolirabe.svg": 83831,
	"./brownies.svg": 83703,
	"./brusselssprouts.svg": 82051,
	"./butter.svg": 8484,
	"./butternutsquash.svg": 72920,
	"./cake.svg": 82382,
	"./candy.svg": 85611,
	"./cantaloupe.svg": 19742,
	"./capers.svg": 4006,
	"./caramel.svg": 64443,
	"./carrots.svg": 10240,
	"./cashews.svg": 26292,
	"./cassava.svg": 63132,
	"./cauliflower.svg": 72753,
	"./celery.svg": 11648,
	"./cheese.svg": 79373,
	"./cherries.svg": 41369,
	"./chicken.svg": 25305,
	"./chickpea.svg": 60364,
	"./chilepeppers.svg": 94576,
	"./chives.svg": 50818,
	"./chocolate.svg": 65934,
	"./chocolatechips.svg": 28501,
	"./chorizo.svg": 7758,
	"./churro.svg": 2063,
	"./cinnamonroll.svg": 15586,
	"./clams.svg": 18642,
	"./clementines.svg": 2451,
	"./cobbler.svg": 51103,
	"./coconutmeat.svg": 54700,
	"./coldcut.svg": 20370,
	"./collardgreens.svg": 49353,
	"./cookies.svg": 55249,
	"./corn.svg": 66272,
	"./cottagecheese.svg": 45144,
	"./crab.svg": 95280,
	"./cranberries.svg": 25658,
	"./crayfish.svg": 93757,
	"./cream.svg": 81954,
	"./cremebrulee.svg": 14179,
	"./crepe.svg": 45933,
	"./croissant.svg": 28760,
	"./cucumber.svg": 2414,
	"./cupcake.svg": 55704,
	"./currants.svg": 76372,
	"./dairy.svg": 21945,
	"./date.svg": 36542,
	"./dough.svg": 78393,
	"./doughnuts.svg": 79577,
	"./dragonfruit.svg": 7809,
	"./driedfruit.svg": 77516,
	"./driedherb.svg": 35833,
	"./eclair.svg": 14470,
	"./edamame.svg": 69220,
	"./eggplant.svg": 18648,
	"./eggs.svg": 37204,
	"./endive.svg": 96509,
	"./englishmuffin.svg": 5827,
	"./escarole.svg": 27702,
	"./fatorsugar.svg": 93222,
	"./fennel.svg": 79326,
	"./figs.svg": 6487,
	"./fish.svg": 65648,
	"./flour.svg": 89868,
	"./food.svg": 34190,
	"./frenchfries.svg": 88185,
	"./frozenyogurt.svg": 43690,
	"./fruit.svg": 84678,
	"./fudge.svg": 10837,
	"./garlic.svg": 67924,
	"./gelatindessert.svg": 96702,
	"./gelato.svg": 59892,
	"./ginger.svg": 68730,
	"./gluten.svg": 4613,
	"./goat.svg": 41163,
	"./gooseberries.svg": 51689,
	"./grain.svg": 26025,
	"./grapefruit.svg": 9447,
	"./grapes.svg": 63550,
	"./greenbeans.svg": 16460,
	"./greenbellpepper.svg": 50614,
	"./greencabbage.svg": 53144,
	"./greenonions.svg": 68111,
	"./groundmeat.svg": 60950,
	"./guavas.svg": 91027,
	"./ham.svg": 47914,
	"./hazelnuts.svg": 4914,
	"./heartofpalm.svg": 2499,
	"./herb.svg": 41215,
	"./honeydew.svg": 41709,
	"./icecream.svg": 73115,
	"./jalapenopeppers.svg": 96797,
	"./jerky.svg": 53831,
	"./jicama.svg": 50667,
	"./kale.svg": 81651,
	"./kiwi.svg": 42382,
	"./kohlrabi.svg": 43180,
	"./lamb.svg": 19750,
	"./leafygreen.svg": 29444,
	"./leeks.svg": 13152,
	"./lemons.svg": 20542,
	"./lentil.svg": 54314,
	"./lentils.svg": 82959,
	"./lettuce.svg": 86554,
	"./limes.svg": 890,
	"./lobster.svg": 78587,
	"./lychee.svg": 25204,
	"./macadamias.svg": 57527,
	"./mangos.svg": 65495,
	"./mayonnaise.svg": 74394,
	"./milk.svg": 247,
	"./muffin.svg": 10481,
	"./mussels.svg": 68522,
	"./mustardgreens.svg": 18482,
	"./napacabbage.svg": 90103,
	"./nectarines.svg": 74280,
	"./noodles.svg": 22372,
	"./nut.svg": 47933,
	"./nutmilk.svg": 35840,
	"./octopus.svg": 52187,
	"./oil.svg": 54072,
	"./okra.svg": 61223,
	"./olives.svg": 45754,
	"./onions.svg": 49044,
	"./oranges.svg": 19981,
	"./organmeat.svg": 98842,
	"./other.svg": 16146,
	"./oysters.svg": 88311,
	"./pancakes.svg": 61190,
	"./papaya.svg": 45500,
	"./parsley.svg": 17162,
	"./parsnips.svg": 67170,
	"./passionfruit.svg": 75329,
	"./pasta.svg": 35937,
	"./pea.svg": 95418,
	"./peaches.svg": 67355,
	"./peanutbutter.svg": 7351,
	"./peanuts.svg": 2974,
	"./pears.svg": 4431,
	"./pecan.svg": 47857,
	"./pepper.svg": 3870,
	"./pepperoni.svg": 24172,
	"./persimmon.svg": 51096,
	"./pickle.svg": 7624,
	"./pie.svg": 29538,
	"./pimento.svg": 96316,
	"./pineapple.svg": 82214,
	"./pinenuts.svg": 42676,
	"./pistachios.svg": 54889,
	"./pizza.svg": 13426,
	"./plums.svg": 6541,
	"./pluot.svg": 31316,
	"./pomegranate.svg": 28733,
	"./pork.svg": 55004,
	"./portabellamushrooms.svg": 46087,
	"./potatochips.svg": 48422,
	"./potatognocchi.svg": 18,
	"./prawns.svg": 62629,
	"./protein.svg": 49605,
	"./proteinpowder.svg": 96894,
	"./pudding.svg": 28583,
	"./pumpkin.svg": 48724,
	"./quark.svg": 98970,
	"./radicchio.svg": 88048,
	"./radishes.svg": 11913,
	"./raisin.svg": 24,
	"./rambutan.svg": 64658,
	"./raspberries.svg": 12858,
	"./recipe.svg": 32868,
	"./redbellpepper.svg": 32838,
	"./redcabbage.svg": 93448,
	"./redpotato.svg": 82740,
	"./rhubarb.svg": 60748,
	"./ribs.svg": 96128,
	"./rice.svg": 53989,
	"./russetpotato.svg": 70305,
	"./rutabaga.svg": 66791,
	"./salmon.svg": 81348,
	"./sauce.svg": 46517,
	"./sauerkraut.svg": 15217,
	"./scallops.svg": 47251,
	"./seaweed.svg": 56906,
	"./seed.svg": 58841,
	"./serranopepper.svg": 1384,
	"./shallots.svg": 57924,
	"./shellfish.svg": 77820,
	"./shiitakemushrooms.svg": 40827,
	"./sorbet.svg": 65331,
	"./sourcream.svg": 73223,
	"./soy.svg": 56319,
	"./spaghettisquash.svg": 52210,
	"./spice.svg": 8218,
	"./spinach.svg": 36248,
	"./squid.svg": 86398,
	"./starfruit.svg": 49274,
	"./stock.svg": 76978,
	"./strawberries.svg": 26381,
	"./strudel.svg": 22053,
	"./summersquash.svg": 25306,
	"./sweetener.svg": 82748,
	"./sweetpotato.svg": 71265,
	"./swisschard.svg": 66493,
	"./tangerine.svg": 56281,
	"./taro.svg": 42078,
	"./tilapia.svg": 42526,
	"./tomatillo.svg": 97275,
	"./tomatoes.svg": 7696,
	"./tortilla.svg": 21461,
	"./tuna.svg": 46452,
	"./turkey.svg": 64436,
	"./turnipgreens.svg": 94776,
	"./turnips.svg": 79581,
	"./vegetable.svg": 12733,
	"./vinegar.svg": 69162,
	"./waffles.svg": 57952,
	"./walnuts.svg": 14572,
	"./wasabi.svg": 47053,
	"./watercress.svg": 86431,
	"./watermelon.svg": 87372,
	"./whitemushrooms.svg": 58262,
	"./whitepotato.svg": 31654,
	"./wholegrain.svg": 81268,
	"./wine.svg": 62385,
	"./yams.svg": 92628,
	"./yogurt.svg": 2944,
	"./zucchini.svg": 47089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58301;